var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
// Styling
import styles from './Asset.css.js';
/**
 * @element zz-asset
 */
export class Asset extends LitElement {
    static get styles() {
        return [styles];
    }
    get assets() {
        return {
            'digid': html `
                <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" fill-rule="evenodd">
                        <path
                            d="m63.7619021 54.8072727c0 4.9221818-4.0275245 8.9497063-8.9497063 8.9497063h-45.5330909c-4.92262938 0-8.95015385-4.0275245-8.95015385-8.9497063v-45.53309088c0-4.92218182 4.02752447-8.9497063 8.95015385-8.9497063h45.5330909c4.9221818 0 8.9497063 4.02752448 8.9497063 8.9497063z"
                            fill="#000"
                        />
                        <g fill="#fffffe">
                            <path
                                d="m7.86662937 34.355021h5.20637763c3.9344336 0 7.1751608 3.0903496 7.1751608 7.0610349 0 3.9724756-3.2604195 7.0628252-7.1751608 7.0628252h-5.20637763zm3.67127273 11.0142657h.8243916c2.1916643 0 4.0642238-1.2003357 4.0642238-3.9532308 0-2.5268811-1.6671329-3.9518881-4.0270769-3.9518881h-.8615385z"
                            />
                            <path d="m21.5398042 48.4793287h3.4099021v-9.6102937h-3.4099021z" />
                            <path
                                d="m37.3509371 47.5417063c0 4.0839161-2.0233847 5.7318042-5.5635245 5.7318042-2.2104616 0-5.1696783-1.1421539-5.4690909-3.6703776h3.8212028c.0926433.3361119.3361119.5795804.6364196.7295105.2998601.1494825.6552167.2246713.9743216.2246713 1.8363077 0 2.1916644-1.198993 2.1916644-2.7528951v-.4493427c-.8807832.8798881-1.7799161 1.3104336-3.0532028 1.3104336-2.8097343 0-4.7391329-2.1352727-4.7391329-4.906965 0-2.8106294 1.9853427-5.2081679 4.9262098-5.2081679 1.1242517 0 2.1540699.3741539 2.8294266 1.3305734h.0366993v-1.011916h3.409007zm-7.6808951-3.9335385c0 1.2182378.8055944 2.1545175 2.1925594 2.1545175 1.3860699 0 2.1916643-.9362797 2.1916643-2.1545175 0-1.1793007-.8055944-2.1728671-2.1916643-2.1728671-1.386965 0-2.1925594.9935664-2.1925594 2.1728671z"
                            />
                        </g>
                        <path d="m39.1487552 48.4793287h3.4094546v-9.6102937h-3.4094546z" fill="#eb9036" />
                        <path
                            d="m44.5583217 34.355021h5.2068252c3.933986 0 7.1747132 3.0903496 7.1747132 7.0610349 0 3.9724756-3.2595244 7.0628252-7.1747132 7.0628252h-5.2068252zm3.6712727 11.0142657h.8239441c2.1912167 0 4.0651188-1.2003357 4.0651188-3.9532308 0-2.5268811-1.6680279-3.9518881-4.027972-3.9518881h-.8610909z"
                            fill="#eb9036"
                        />
                        <path
                            d="m25.1716923 35.2102937c0 1.0481678-.8615385 1.9101539-1.9106014 1.9101539-1.0495105 0-1.9106014-.8619861-1.9106014-1.9101539 0-1.0495105.8610909-1.9110489 1.9106014-1.9110489 1.0490629 0 1.9106014.8615384 1.9106014 1.9110489"
                            fill="#fffffe"
                        />
                        <path
                            d="m42.722014 35.2102937c0 1.0481678-.861986 1.9097063-1.9097063 1.9097063-1.0504056 0-1.9119441-.8615385-1.9119441-1.9097063 0-1.0495105.8615385-1.9110489 1.9119441-1.9110489 1.0477203 0 1.9097063.8615384 1.9097063 1.9110489"
                            fill="#eb9036"
                        />
                    </g>
                </svg>
            `,
            'file-card': html ` <svg
                class="file-card"
                width="104"
                height="104"
                viewBox="0 0 104 104"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="104" height="104">
                    <path d="M0 0H80L104 24V104H0V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0)">
                    <path d="M0 0H80L104 24V104H0V0Z" fill="#BDBDBC" />
                    <g filter="url(#filter0_d)">
                        <path d="M104 24H88.8243C84.1851 24 80 19.8149 80 15.1757V0L104 24Z" fill="#BDBDBC" />
                    </g>
                    <path
                        d="M104 24H88.8243C84.1851 24 80 19.8149 80 15.1757V0L104 24Z"
                        fill="white"
                        fill-opacity="0.4"
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_d"
                        x="78"
                        y="0"
                        width="28"
                        height="28"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        />
                        <feOffset dy="2" />
                        <feGaussianBlur stdDeviation="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                    </filter>
                </defs>
            </svg>`,
        };
    }
    render() {
        return this.assets[this.type];
    }
}
__decorate([
    property({ type: String })
], Asset.prototype, "type", void 0);
